import { render, staticRenderFns } from "./FoodMovement.vue?vue&type=template&id=8d9a55e0&"
import script from "./FoodMovement.vue?vue&type=script&lang=js&"
export * from "./FoodMovement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports